import { Col } from 'antd';
import React from 'react'

const MacroDetails = ({productbase, detail, type}) => {
    return (
        <Col xs={24} lg={12}>
            <div className="macro">
                <h6 className="font-weight-bolder mb-2 text-capitalize">
                    {type}
                </h6>
                <div className="table-responsive">
                    <table
                        className="table table-bordered text-center m-0"
                        border="0"
                        cellSpacing="0"
                        cellPadding="0"
                        width="100%"
                    >
                        <thead className="text-white bg-gray-700">
                            <tr>
                                <th>
                                    {productbase ===
                                        "FEED_SUPPLEMENT"
                                        ? "Quantity"
                                        : "Percentage"}
                                </th>
                                <th>
                                    {productbase ===
                                        "FEED_SUPPLEMENT"
                                        ? "Ingredient"
                                        : "Chemical"}{" "}
                                    Name
                                </th>
                                <th>
                                    {" "}
                                    {productbase ===
                                        "FEED_SUPPLEMENT"
                                        ? "Unit"
                                        : "Formulation"}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="font-weight-bolder">
                            {detail?.productDetails
                                ?.composition?.[type]
                                ?.length > 0 ? (
                                detail?.productDetails?.composition?.[type]?.map(
                                    (macro, index) => {
                                        return (
                                            <tr
                                                key={index.toString()}
                                            >
                                                <td className="align-middle">
                                                    {
                                                        macro?.percentage
                                                    }
                                                </td>
                                                <td className="align-middle font-weight-bold">
                                                    {
                                                        macro?.chemical
                                                            ?.en
                                                    }
                                                </td>
                                                <td className="align-middle font-weight-bold">
                                                    {
                                                        macro?.formulation
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={3}>
                                        No Data Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Col>
    )
}

export default MacroDetails